import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import { MEMORY_MAP_IMAGES } from '../../shared/memory-map-assets';
import styles from './StartSlideV20.css';

function StartSlideV20({ id, onContinue }) {
    const handleStart = () => {
        logEvent(EVENT_TYPES.QUIZ_START_CLICKED, { label: 'Start' });
        onContinue();
    };

    return (
        <section className={styles.form} key={id}>
            <div className={styles.top}>
                <p className={styles.kicker}>Map your memories in 3 minutes</p>
                <img
                    src={MEMORY_MAP_IMAGES.HERO}
                    alt=''
                    className={styles.hero}
                    width='960'
                    height='960'
                />
                <div className={styles.text}>
                    <h1 className={styles.heading}>What comes back first?</h1>
                    <p className={styles.description}>An immersive quiz through home, school and first love to personalize your subscription</p>
                </div>
            </div>
            <Button
                type='sunset'
                label='Start'
                onClick={handleStart}
                className={styles.button}
                inSlide
            />
        </section>
    );
}

StartSlideV20.propTypes = {
    id: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired
};

export {
    StartSlideV20
};
